export const sealSetupRouting = [
	{
    path: "/sealManage/sealSetUp/list",
    name: "sealSetUp-list",
    meta: { title: "印章设置" },
    component: () =>
      import(/* webpackChunkName: "sealSetup-list" */ "@/views/seal-management/sealSetUp/list/index.vue"),
  },
]